module.exports = __webpack_public_path__ + "static/media/caution_circle.e4e112c5.svg";